import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-layers",
  templateUrl: "./med-icon-layers.component.html",
})
export class MedIconLayersComponent extends SvgMixinComponent {}
